<template>
  <div class="impersonate">
    <span v-html="t('You are logged as <b>{0}</b>.', [store.impersonation.email])"></span>&nbsp;<button class="logout" @click="logout">{{ t('Return back to my account') }}</button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';
import { useStore } from '@/store';

const { t } = useI18n();
const store = useStore();

const logout = () => {
  window.sessionStorage.removeItem('impersonation');
  window.location.reload();
};
</script>

<style lang="scss" scoped>
.logout {
  text-decoration: underline;
  cursor: pointer;
}
.impersonate {
  background-color: var(--color-green20);
  padding:4px 0;
  text-align: center;
}
</style>
